/**
 * Empresa desativada: o que a tela faz com ela.
 *
 * O `/me` só entrega empresa desativada ao Máster (quem não é
 * nem a recebe), e ele precisa dela na lista — pra reativar e pra
 * conferir antes. Mas ela não é lugar onde ninguém "escolhe trabalhar":
 * toda decisão de "qual empresa abrir por padrão" passa por
 * `activeCompanies`, e a lista inteira só aparece onde o Máster
 * gerencia (o hub, no filtro "Inativas" e "Todas").
 */

/** O aviso do hub quando uma chamada volta o 403 de empresa desativada.
 * Mesma redação do servidor, mas a tela NÃO depende dela: o gatilho é o
 * `code`, esta frase é só o que se mostra. */
export const COMPANY_DISABLED_NOTICE =
  "Esta empresa foi desativada. Fale com um Máster.";

export function activeCompanies<T extends { is_active: boolean }>(companies: T[]): T[] {
  return companies.filter(company => company.is_active);
}
